import React from "react";
import {
  ButtonDelete,
  ButtonEdit,
  EditElementClick,
} from "../../common/Buttons";
import { GoCheck, GoPrimitiveDot } from "react-icons/go";

function TableColumnSms({ id, item, onDelete, index, onAction }) {
  return (
    <tr className="align-middle tableColumn" key={index}>
      <td className="align-middle">
        <GoPrimitiveDot
          style={item.identifier ? { color: "green" } : { color: "red" }}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", item)}
          name={item.country?.en_name || ""}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", item)}
          name={item.message}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", item)}
          name={item.body}
        />
      </td>
      <td className="align-middle">
        <EditElementClick
          onEdit={() => onAction("edit", item)}
          name={item.identifier}
        />
      </td>
      <td className="align-middle">
        {item.technorama && <GoCheck className={"text-success"} />}
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonEdit onEdit={() => onAction("edit", item)} />
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonDelete onDelete={() => onDelete(id)} />
      </td>
    </tr>
  );
}

export default TableColumnSms;
